import { useEffect, useLayoutEffect, useRef } from "react";

/** Declarative setInterval — re-reads the latest callback without resetting the timer. */
function useInterval(callback: () => void, delay: number | null) {
	const savedCallback = useRef(callback);

	useLayoutEffect(() => {
		savedCallback.current = callback;
	}, [callback]);

	useEffect(() => {
		// Don't schedule when no delay is given (0 is valid).
		if (!delay && delay !== 0) {
			return;
		}
		const id = setInterval(() => savedCallback.current(), delay);
		return () => clearInterval(id);
	}, [delay]);
}

export default useInterval;
